import React from 'react'
import { observer } from 'mobx-react'
import ScopeChangeRequestDetailsViewModel from './ScopeChangeRequestDetailsViewModel'
import DetailsHeader from './DetailsHeader'
import InfoSection from './InfoSection'
import ResponsesSection from './ResponsesSection'
import InventoryItemsSection from './ItemsSection/InventoryItemsSection'
import CustomItemsSection from './ItemsSection/CustomItemsSection'
import DetailsFooter from './DetailsFooter'
import styles from './ScopeChangeRequestDetailsPanel.sass'

interface ScopeChangeRequestDetailsPanelProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export default observer(function ScopeChangeRequestDetailPanel({
  vm,
}: ScopeChangeRequestDetailsPanelProps) {
  return vm.showing ? (
    <div className={styles.root}>
      <DetailsHeader onClose={vm.close} />
      <InfoSection vm={vm} />
      <ResponsesSection vm={vm} />
      <InventoryItemsSection vm={vm} />
      <CustomItemsSection vm={vm} />
      <DetailsFooter vm={vm} />
    </div>
  ) : null
})
